import { z } from 'zod';

import { RevisionPlanResolvedSlotSchema } from './revision-plan.schemas.js';

export const ResolveRevisionPlanBodySchema = z.object({
  vehicleModelId: z.uuid().optional(),
  manufactureYear: z.number().int().min(1900).max(2100).optional(),
  vehicleEngineId: z.uuid().optional(),
  placeId: z.uuid().optional(),
});

export const ResolveRevisionPlanResponseSchema = z.object({
  revisionPlanId: z.uuid(),
  name: z.string(),
  slots: z.array(RevisionPlanResolvedSlotSchema),
});

export type ResolveRevisionPlanBody = z.infer<typeof ResolveRevisionPlanBodySchema>;
export type ResolveRevisionPlanResponse = z.infer<typeof ResolveRevisionPlanResponseSchema>;
